<template>
    <div class="delete-favorite-item">
        <p>{{ message.textDeleteGroup }}</p>
        <form class="delete-favorite-item__form" @submit.prevent="deleteGroup">
            <input v-if="staticHiddenData" v-for="(hiddenFieldValue, name)  in staticHiddenData" type="hidden" :name="name" :value="hiddenFieldValue">
            <button type="submit" >{{ message.btnDel }}</button>
            <span @click="closeBlock">{{ message.btnCancel }}</span>
        </form>
    </div>
</template>

<script>
import {mapState} from "vuex";

export default {
    name: "delete-favorite-item",
    props: ['groupId'],
    data(){
        return{
            close: false,
        }
    },
    computed: {
        ...mapState({
            staticHiddenData: ({ favourite }) => favourite?.data?.routes.staticHiddenData,
            message: ({ favourite }) => favourite?.data?.message,
        })
    },
    methods: {
        closeBlock() {
            this.$emit('showRemoveBlock', this.close)
        },
        deleteGroup({target}) {
            const formData = new FormData(target)
            formData.append('groupId', this.groupId)
            this.$store.dispatch('favourite/deleteFavoriteGroup', formData);
            this.closeBlock();
        }
    }
}
</script>

<style scoped lang="scss">
    .delete-favorite-item{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 100%;

        @include point-md{
            align-items: center;
            flex-direction: row;
        }
        @include point-lg{
            margin: 18px 0;
        }
        &__form{
            display: flex;
            align-items: center;
            margin: 24px 0;

            @include point-md{
                margin: 0
            }

            button{
                display: block;
                height: 48px;
                background: #618EAF;
                color: #fff;
                font-size: rem(14);
                margin-right: 16px;
                padding: 0 48px;
                transition: .2s linear background;
                text-transform: uppercase;

                &:hover{
                    background: rgba(97, 142, 175, .8);
                    transition: .2s linear background;
                }
            }
            span{
                color: #618EAF;
                font-size: rem(12);
                line-height: 115%;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                border-bottom: rem(1) dashed #618EAF;
                cursor: pointer;
            }
        }
    }
</style>